<template>
  <div v-loading="loading" class="c-form-item-acitivty-sort" :class="{ disabled }">
    <el-table ref="tableRef" :data="activityItems" max-height="300" border>
      <el-table-column prop="sort" label="优先级" width="80" align="center">
        <template #default="{ row, $index }">
          <div class="sort-cell" :class="{ first: $index <= 0, last: $index >= activityItems.length - 1 }">
            <div class="label">{{ row.sort }}</div>
            <div v-if="row.current" class="caret-wrapper">
              <i class="sort-caret ascending" @click="handleUp" />
              <i class="sort-caret descending" @click="handleDown" />
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="activityName" label="活动名称" min-width="140" align="center"></el-table-column>
<!--      <el-table-column prop="cycleType" label="循环周期" width="80" align="center">-->
<!--        <template #default="{ row }">-->
<!--          {{ getCommonOptionItem('activityCycleType', row.cycleType, 'label') || '&#45;&#45;' }}-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column prop="dateDesc" label="活动时间" min-width="160" align="center"></el-table-column>
    </el-table>
  </div>
</template>

<script setup lang="ts">
import { _, computed, ref, watch, debound, onMounted, useCurrentAppInstance } from '@zto/zpage'

import { getCommonOptionItem } from '@/utils'
import { getActivitDateDesc } from '../utils'

const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    disabled?: boolean
  }>(),
  {
    disabled: false
  }
)

const app = useCurrentAppInstance()

const loading = ref<boolean>(false)

const activityItems = ref<any[]>([])

const activityPlace = computed(() => {
  return props.model.activityPlace
})

watch(() => props.model, debound(onModelChange), { deep: true })

watch(
  () => props.model.sort,
  (cur, old) => {
    if (cur === old) return

    onActivitySortChange()
  },
  { immediate: true }
)

const innerApiParams = computed(() => {
  return { activityPlace: activityPlace.value }
})

watch(
  () => innerApiParams.value,
  (cur, old) => {
    if (_.deepEqual(cur, old)) return

    handleFetch()
  }
)

onMounted(() => {
  handleFetch()
})

function handleUp() {
  exchangeItemSort('up')
}

function handleDown() {
  exchangeItemSort('down')
}

function onModelChange() {
  if (!props.model) return

  const currentIndex = activityItems.value.findIndex(it => it.current)
  const currentRow = activityItems.value[currentIndex]

  if (!currentRow) return

  activityItems.value[currentIndex] = {
    ...props.model,
    dateDesc: getActivitDateDesc(props.model),
    sort: currentRow.sort,
    current: true
  }
}

/** 交互优先级，direction: up/down */
function exchangeItemSort(direction: 'up' | 'down') {
  const currentIndex = activityItems.value.findIndex(it => it.current)
  const currentRow = activityItems.value[currentIndex]
  if (!currentRow) return

  const swapIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1
  const swapRow = activityItems.value[swapIndex]
  if (!swapRow) return

  let swapSort = swapRow.sort
  if (swapSort === currentRow.sort) {
    swapSort = direction === 'up' ? swapSort - 1 : swapSort + 1
  }

  swapRow.sort = currentRow.sort
  currentRow.sort = swapSort

  props.model.sort = currentRow.sort
  activityItems.value = sortItems(activityItems.value)
}

const handleFetch = debound(async () => {
  doFetch()
}, 1000)

async function doFetch() {
  if (!checkApiParams()) return

  loading.value = false

  // const res = await app
  //   .request({
  //     api: { url: 'tuxi.txsh.cms.pc.queryActivitysByPlace' },
  //     params: innerApiParams.value
  //   })
  //   .finally(() => {
  //     loading.value = false
  //   })

  const items = sortItems( [])

  // 重新从1开始排序
  items.forEach((it, index) => {
    it.sort = index + 1
  })

  const currentItemIndex = items.findIndex((it: any) => it.activityCode === props.model?.activityCode)
  let currentSort = 1
  if (currentItemIndex >= 0) {
    items[currentItemIndex].current = true
    currentSort = items[currentItemIndex].sort
  } else {
    currentSort = (items[items.length - 1]?.sort || 0) + 1
    items.push({ ...props.model, sort: currentSort, current: true })
  }

  items.forEach((it: any) => {
    it.dateDesc = getActivitDateDesc(it)
  })

  activityItems.value = items

  props.model.sort = currentSort

  onActivitySortChange()
}

/** 判断请求参数是否合法 */
function checkApiParams() {
  const params = innerApiParams.value

  if (!params?.activityPlace) return false

  return true
}

function sortItems(items: any[]) {
  return items.sort((a: any, b: any) => a.sort - b.sort)
}

function onActivitySortChange() {
  props.model.activitySortList = activityItems.value.map(it => ({
    activityCode: it.activityCode,
    sort: it.sort
  }))
}
</script>

<style lang="scss" scoped>
.c-form-item-acitivty-sort {
  .sort-cell {
    display: inline-block;
    box-sizing: border-box;
    position: relative;

    .label {
      display: inline-block;
    }

    .caret-wrapper {
      position: absolute;
      top: 5px;
      left: 15px;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      height: 14px;
      width: 24px;
      vertical-align: middle;
      cursor: pointer;

      & > i {
        width: 0;
        height: 0;
        border: solid 7px transparent;
        position: absolute;
        left: 7px;

        &:hover {
          opacity: 0.8;
        }

        &.ascending {
          border-bottom-color: grey;
          top: -9px;
        }

        &.descending {
          border-top-color: grey;
          bottom: -9px;
        }
      }
    }

    &.first i.ascending {
      opacity: 0.5;
      cursor: default;
    }

    &.last i.descending {
      opacity: 0.5;
      cursor: default;
    }
  }

  &.disabled {
    .caret-wrapper {
      display: none;
    }
  }
}
</style>
